// // HeroBanner.jsx

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import "../styles/HeroBanner.css";

// const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
// const IMAGE_BASE = "https://afrogebeya.com/uploads/products";

// const PLACEHOLDER = "https://via.placeholder.com/700x700?text=Afrogebeya";

// const resolveImage = (url) => {
//   if (!url) return PLACEHOLDER;

//   return `${IMAGE_BASE}/${url.replace(/\\/g, "/")}`;
// };

// const createSlug = (name = "", id) =>
//   `${name
//     .toLowerCase()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/(^-|-$)/g, "")}-${id}`;

// export default function HeroBanner() {
//   const navigate = useNavigate();

//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchHeroProducts = async () => {
//       try {
//         setLoading(true);

//         const res = await axios.get(`${PRODUCT_API}/products/buyers`, {
//           params: {
//             page: 0,
//             size: 5,
//           },
//         });

//         setProducts(res.data?.content || []);
//       } catch (err) {
//         console.error("Failed to fetch hero products", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHeroProducts();
//   }, []);

//   if (loading || !products.length) return null;

//   return (
//     <section className="hero-wrapper">
//       <div
//         id="homeHeroCarousel"
//         className="carousel slide home-hero-carousel"
//         data-bs-ride="carousel"
//         data-bs-interval="5000"
//       >
//         {/* Indicators */}
//         <div className="carousel-indicators">
//           {products.map((_, index) => (
//             <button
//               key={index}
//               type="button"
//               data-bs-target="#homeHeroCarousel"
//               data-bs-slide-to={index}
//               className={index === 0 ? "active" : ""}
//               aria-current={index === 0}
//               aria-label={`Slide ${index + 1}`}
//             />
//           ))}
//         </div>

//         {/* Slides */}
//         <div className="carousel-inner">
//           {products.map((product, index) => (
//             <div
//               key={product.id}
//               className={`carousel-item ${index === 0 ? "active" : ""}`}
//             >
//               <div className="home-hero-slide">
//                 {/* Overlay */}
//                 <div className="home-hero-overlay" />

//                 {/* LEFT CONTENT */}
//                 <div className="home-hero-content">
//                   <span className="home-hero-badge">Featured Product</span>

//                   <h1>{product.productName}</h1>

//                   <p>
//                     Discover premium quality products from trusted Afrogebeya
//                     sellers across Africa.
//                   </p>

//                   <div className="hero-buttons">
//                     <button
//                       className="btn btn-warning hero-btn-primary"
//                       onClick={() =>
//                         navigate(
//                           `/products/${createSlug(
//                             product.productName,
//                             product.id,
//                           )}`,
//                         )
//                       }
//                     >
//                       View Product
//                     </button>

//                     <button
//                       className="btn btn-outline-light hero-btn-secondary"
//                       onClick={() => navigate("/search")}
//                     >
//                       Browse More
//                     </button>
//                   </div>
//                 </div>

//                 {/* RIGHT IMAGE */}
//                 <div className="home-hero-image-wrapper">
//                   <img
//                     src={resolveImage(product.mainImageUrl)}
//                     alt={product.productName}
//                     className="home-hero-image"
//                     loading={index === 0 ? "eager" : "lazy"}
//                     onError={(e) => {
//                       e.target.src = PLACEHOLDER;
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Controls */}
//         <button
//           className="carousel-control-prev"
//           type="button"
//           data-bs-target="#homeHeroCarousel"
//           data-bs-slide="prev"
//         >
//           <span className="carousel-control-prev-icon" aria-hidden="true" />
//         </button>

//         <button
//           className="carousel-control-next"
//           type="button"
//           data-bs-target="#homeHeroCarousel"
//           data-bs-slide="next"
//         >
//           <span className="carousel-control-next-icon" aria-hidden="true" />
//         </button>
//       </div>
//     </section>
//   );
// }

// HeroBanner.jsx

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "../styles/HeroBanner.css";

const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
const IMAGE_BASE = "https://afrogebeya.com/uploads/products";

const PLACEHOLDER = "https://via.placeholder.com/500x500?text=Afrogebeya";

const PRODUCTS_PER_SLIDE = 5;

const resolveImage = (url) => {
  if (!url) return PLACEHOLDER;

  return `${IMAGE_BASE}/${url.replace(/\\/g, "/")}`;
};

const createSlug = (name = "", id) =>
  `${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}-${id}`;

export default function HeroBanner() {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeroProducts = async () => {
      try {
        setLoading(true);

        const res = await axios.get(`${PRODUCT_API}/products/buyers`, {
          params: {
            page: 0,
            size: 25,
          },
        });

        setProducts(res.data?.content || []);
      } catch (err) {
        console.error("Failed to fetch hero products", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroProducts();
  }, []);

  const groupedProducts = useMemo(() => {
    const groups = [];

    for (let i = 0; i < products.length; i += PRODUCTS_PER_SLIDE) {
      groups.push(products.slice(i, i + PRODUCTS_PER_SLIDE));
    }

    return groups;
  }, [products]);

  if (loading || !groupedProducts.length) return null;

  return (
    <section className="hero-wrapper">
      <div
        id="homeHeroCarousel"
        className="carousel slide home-hero-carousel"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        {/* Indicators */}
        <div className="carousel-indicators">
          {groupedProducts.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#homeHeroCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          {groupedProducts.map((slideProducts, slideIndex) => (
            <div
              key={slideIndex}
              className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
            >
              <div className="home-hero-slide">
                {/* Left Promo */}
                {/* <div className="hero-promo-section">
                  <span className="home-hero-badge">
                    Trending on Afrogebeya
                  </span>

                  <h2>Discover Africa’s Fast Growing Marketplace</h2>

                  <p>
                    Shop fashion, electronics, beauty, home essentials and more
                    from trusted sellers.
                  </p>

                  <button
                    className="btn btn-warning hero-shop-btn"
                    onClick={() => navigate("/search")}
                  >
                    Shop Now
                  </button>
                </div> */}

                {/* Products */}
                <div className="hero-products-grid">
                  {slideProducts.map((product) => (
                    <div
                      key={product.id}
                      className="hero-product-card"
                      onClick={() =>
                        navigate(
                          `/products/${createSlug(
                            product.productName,
                            product.id,
                          )}`,
                        )
                      }
                    >
                      <div className="hero-product-image-wrapper">
                        <img
                          src={resolveImage(product.mainImageUrl)}
                          alt={product.productName}
                          className="hero-product-image"
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = PLACEHOLDER;
                          }}
                        />
                      </div>

                      <div className="hero-product-info">
                        <h6>{product.productName}</h6>

                        {product.price && (
                          <span className="hero-product-price">
                            {product.price}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#homeHeroCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" />
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#homeHeroCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" />
        </button>
      </div>
    </section>
  );
}
